import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import { FaSearch } from 'react-icons/fa';

import S from './search-input.module.scss';

const SearchInput = ({ placeholder, onChange, gridArea, isDisabled, className, value }) => {
  const [inputValue, setInputValue] = React.useState(value);

  React.useEffect(() => {
    setInputValue(value);
    }, [value]);

  const onInputChange = (e) => {
    setInputValue(e.target.value);
    onChange && onChange(e);
  };

  return (
    <div className={classNames(S.searchInput, { [className]: className })} style={{ gridArea }}>
      <input type='search' onChange={onInputChange} placeholder={placeholder} disabled={isDisabled} value={inputValue} />
      <FaSearch />
    </div>
  );
};

SearchInput.displayName = 'SearchInput';

SearchInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  margin: PropTypes.string,
  gridArea: PropTypes.string,
  isDisabled: PropTypes.bool,
};

SearchInput.defaultProps = {
  placeholder: 'Filter',
  className: null,
  value: '',
  isDisabled: false,
};

export { SearchInput };
